export const getMediaFilterOptionValue = (option: unknown) => {
  return option as string;
};
